import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  Spinner,
  InfoDisplay
} from '../'

class ContactSummary extends React.Component {
  static propTypes = {
    contactId: PropTypes.string.isRequired
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='small' />
    }

    const contactRecord = this.props.data.contact

    let contactInfoRows = (<tbody>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Employer / Division</th>
          <td>
            {/* TODO: add NavLink */}
            {contactRecord.employer
              ? contactRecord.employer.friendlyName +
                (contactRecord.employer.division
                  ? " / " +contactRecord.employer.division.name
                  : ""
                )
              : ""
            }
          </td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Position</th>
          <td>
            {contactRecord.position}
          </td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Role</th>
          <td>
            {contactRecord.role}
          </td>
      </tr>
    </tbody>)

    return (
      <InfoDisplay
        title={this.props.title}
        rows={contactInfoRows}
        titleBold={true}
        noButtons={true}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getContactSummary = gql`query($id: ID!) {
    contact(id: $id) {
      ...ContactSummary
    }
  }
  ${fragments.contactSummary}
`

const withData =
  graphql(getContactSummary, {
    options: ({ contactId }) => ({
      variables: {
        id: contactId
      }
    })
  })

export default withData(ContactSummary)



// WEBPACK FOOTER //
// ./src/components/contact-summary/index.js